import React from 'react';
import AppIcon from '../common/AppIcon';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-text">
          &copy; 2026 Doctor Schedule Manager. All rights reserved.
        </p>
        
        <div className="footer-links">
          <a href="#privacy" className="footer-link">
            <AppIcon name="privacy" size={18} strokeWidth={2} />
            Privacy Policy
          </a>
          <a href="#terms" className="footer-link">
            <AppIcon name="terms" size={18} strokeWidth={2} />
            Terms of Service
          </a>
          <a href="#support" className="footer-link">
            <AppIcon name="support" size={18} strokeWidth={2} />
            Support
          </a>
          <span className="footer-version">v1.0.0</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
